export const colorMap = {
  primary: {
    bg: 'bg-primary',
    text: 'text-primary-content',
    hover: 'hover:bg-primary/70',
  },
  secondary: {
    bg: 'bg-secondary',
    text: 'text-secondary-content',
    hover: 'hover:bg-secondary/70',
  },
  neutral: {
    bg: 'bg-neutral',
    text: 'text-neutral-content',
    hover: 'hover:bg-primary hover:text-primary-content',
  },
  accent: {
    bg: 'bg-accent',
    text: 'text-accent-content',
    hover: 'hover:bg-primary/70',
  },
  success: {
    bg: 'bg-success',
    text: 'text-success-content',
    hover: 'hover:bg-success/70',
  },
  error: {
    bg: 'bg-error',
    text: 'text-error-content',
    hover: 'hover:bg-error/70',
  },
  info: {
    bg: 'bg-info',
    text: 'text-info-content',
    hover: 'hover:bg-info/70',
  },
  warning: {
    bg: 'bg-warning',
    text: 'text-warning-content',
    hover: 'hover:bg-warning/70',
  },
}
